import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'shards-react';
import PageTitle from '../../../components/common/PageTitle';
import useForm from './useForm';
import Table from '../../../components/UI/Table/Table';
import { useTranslation } from 'react-i18next';
import { LinearProgress } from '@material-ui/core';

const ListActionLogs = (props) => {
  const { displayOptions } = props;
  const { attributes, actions, listActionLog, findAllActionLog, totalPages, loading, query } = useForm(displayOptions);

  const { t, i18n } = useTranslation();

  return (
    <>
      {loading && <LinearProgress />}
      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header py-4">
          <PageTitle sm="4" title={t('action-log.title.list')} subtitle={t('action-log.subTitle')} className="text-sm-left" />
        </Row>

        <Row>
          <Col>
            <Card small className="mb-4">
              <Table
                attributes={attributes}
                actions={actions}
                data={listActionLog}
                loading={loading}
                search={findAllActionLog}
                numberOfPage={totalPages}
                query={query}
                pdfTitle="Journal d'actions"
              />
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ListActionLogs;
